import React, { Suspense } from "react";
import ReactDOM from 'react-dom';
import { FormattedMessage, injectIntl } from "react-intl";
import { stickers } from "../stores/storages/StickerStorage";
import { recentStickers } from "../stores/storages/RecentStickerStorage.js";
import Config from "../services/config";
import StickerService from "../services/sticker.js";
// import { Picker } from "emoji-mart";

import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { IconBack, IconAdd, IconRecent, IconStickerDefault } from "../icons/svg";
import ButtonSticker, { TYPE_BTN } from "./button-sticker.jsx";
import { DEFAULT_VOICE_STICKERS } from '../tinode/constants.js'

const TAB_STICKER = 1;
const TAB_EMOJI = 2;
const TAB_STORE_STICKER = 3;
const TAB_MANAGE_STICKER = 4;
const SCREEN_STICKER = 1;
const SCREEN_MANAGE_STICKER = 2;
class Stickers extends React.PureComponent {
  constructor(props) {
    super(props);
    const hasRecent =
      recentStickers.stickerRecent && recentStickers.stickerRecent.length > 0;
    this.state = {
      selectedId: 1,
      listStickers: [],
      storeStickers: [],
      manageStickers: [],
      noneDownloadingId: [],
      stickerRecent: recentStickers.stickerRecent || [],
      selectedCollection: DEFAULT_VOICE_STICKERS,
      downloading: false,
      tab: TAB_STICKER,
      screenNumber: SCREEN_STICKER,
    };
    this.handleOnCollectionClick = this.handleOnCollectionClick.bind(this);
    this.renderTicketImage = this.renderTicketImage.bind(this);
    this.processScroll = this.processScroll.bind(this);
    this.handleOnManageClick = this.handleOnManageClick.bind(this);
    this.renderStoreStickers = this.renderStoreStickers.bind(this);
    this.renderManageStickers = this.renderManageStickers.bind(this);
    this.arrayMove = this.arrayMove.bind(this);
    this.handleDownloadCollection = this.handleDownloadCollection.bind(this);
    this.handleDeleteCollection = this.handleDeleteCollection.bind(this);
    this.renderRecentStickerItems = this.renderRecentStickerItems.bind(this);
  }

  componentDidMount() {
    const listStickers = stickers.sticker || [];
    const stickerRecent = recentStickers.stickerRecent || [];
    const storeStickers = listStickers.filter(
      (item) => item.isDownload === undefined || item.isDownload === null
    );
    const manageStickers = listStickers.filter(
      (item) => item.isDownload !== undefined && item.isDownload !== null
    );
    this.processScroll();
    if (listStickers.length === 0) {
      // Tải danh sách sticker
    }
    const listStickersSorted = [DEFAULT_VOICE_STICKERS].concat(manageStickers).concat(storeStickers)
    this.setState({
      listStickers: listStickersSorted,
      storeStickers,
      manageStickers,
      stickerRecent,
      downloading: false,
    });

    document.addEventListener('click', this.handleClickOutside, true);

    if (stickerRecent && stickerRecent.length > 0) {
      this.handleOnCollectionClick(0);
    } else {
      this.handleOnCollectionClick(1);
    }
  }

  componentDidUpdate(prevProps, prevStates) {
    if (prevStates.selectedId !== this.state.selectedId) {
      const selected = this.state.listStickers.filter(
        (item) => item.collectionId === this.state.selectedId
      );
      this.setState({
        selectedCollection: selected.length > 0 ? selected[0] : DEFAULT_VOICE_STICKERS,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside = event => {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      this.props.handleOnClose()
    }
  }

  /**
   *
   * @param {Number} id : collectionId
   */
  handleOnCollectionClick = (id) => {
    this.setState({
      selectedId: id,
    });
  };

  handleOnDownloadSticker = (id) => { };

  handleOnSendStickerMessage = (selectedCollection, sticker) => {
    // Recent sticker
    const collectionId = selectedCollection.collectionId;
    const stickerId = sticker.stickerId;
    const listRecent = recentStickers.stickerRecent || [];
    const objIndex = listRecent.findIndex(
      (obj) => obj.collectionId === collectionId && obj.stickerId === stickerId
    );
    if (objIndex !== -1) {
      const newArr = this.arrayMove(listRecent, objIndex, 0);
      recentStickers.stickerRecent = newArr;
      recentStickers.save();
      this.setState({
        stickerRecent: newArr,
      });
    } else {
      const itemRecent = {
        collectionId,
        stickerId,
        prefix: selectedCollection.prefix,
        img: sticker.img,
        type: sticker.type,
        voice: sticker.voice
      };
      listRecent.unshift(itemRecent);
      recentStickers.stickerRecent = listRecent;
      recentStickers.save();
      this.setState({
        stickerRecent: listRecent,
      });
    }
    this.props.handleOnSendSticker(selectedCollection, sticker);
  };

  handleFocusEmoji = (emoji) => {
    this.selectListeners = [];
    if (emoji) {
      this.selectListeners.forEach((listener) => listener(emoji.native));
      const textMessage = this.props.message + emoji.native;
      this.props.setMessageContent(textMessage);
      this.props.messageEditArea.focus();
    }
  };
  arrayMove = (arr, oldIndex, newIndex) => {
    if (newIndex >= arr.length) {
      let k = newIndex - arr.length + 1;
      while (k) {
        arr.push(undefined);
        k -= 1;
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  };

  updateListSticker = (tabSelected) => {
    const listSticker = stickers.sticker || [];
    const manageStickers = listSticker.filter(
      (item) => item.isDownload !== undefined && item.isDownload !== null
    );
    const storeStickers = listSticker.filter(
      (item) => item.isDownload === undefined || item.isDownload === null
    );

    this.setState({
      manageStickers,
      storeStickers,
      stickerRecent: recentStickers.stickerRecent || [],
      tab: tabSelected,
    });
  };

  handleOnManageClick = () => {
    this.setState({
      tab: TAB_STORE_STICKER,
      screenNumber: SCREEN_MANAGE_STICKER,
    });
  };

  handleDownloadCollection = async (collectionItem) => {
    const newIds = [...this.state.noneDownloadingId].concat([
      collectionItem.collectionId,
    ]);
    this.setState({
      noneDownloadingId: newIds,
    });
    const getDetailCollection = await StickerService.getCollectionDetail(
      collectionItem
    );
    if (getDetailCollection !== undefined) {
      getDetailCollection.isDownload = true;
      getDetailCollection.downloadTime = new Date().getTime();
      const afterIds = [...this.state.noneDownloadingId].filter(
        (item) => item !== collectionItem.collectionId
      );
      const listSticker = stickers.sticker || [];
      const indexRemove = listSticker.findIndex(
        (item) => item.collectionId === collectionItem.collectionId
      );
      listSticker.splice(indexRemove, 1);
      const storeNewList = [getDetailCollection].concat(listSticker);
      stickers.sticker = storeNewList;
      stickers.save();
      const manageStickers = storeNewList.filter(
        (item) => item.isDownload !== undefined && item.isDownload !== null
      );
      const storeStickers = storeNewList.filter(
        (item) => item.isDownload === undefined || item.isDownload === null
      );
      const listStickers = [DEFAULT_VOICE_STICKERS].concat(manageStickers).concat(storeStickers);
      this.setState({
        listStickers,
        manageStickers,
        storeStickers,
        noneDownloadingId: afterIds,
      });
    }
  };

  handleDeleteCollection = (collectionItem) => {
    let collections = stickers.sticker || [];
    const objIndex = collections.findIndex(
      (obj) => obj.collectionId === collectionItem.collectionId
    );
    if (objIndex !== -1) {
      collections[objIndex].isDownload = null;
      collections[objIndex].downloadTime = null;
      const collectionFilter = collections.filter(
        (s) => s.baseURL !== undefined && s.baseURL !== null
      );
      if (collectionFilter && collectionFilter.length > 0) {
        collections = this.arrayMove(
          collections,
          objIndex,
          collectionFilter.length
        );
      }
      const objFirstIndex = collections.findIndex(
        (obj) => obj.collectionId === 1
      );
      collections =
        objFirstIndex > 0
          ? this.arrayMove(collections, objFirstIndex, 0)
          : collections;
      stickers.sticker = collections;
      stickers.save();
      const manageStickers = collections.filter(
        (item) => item.isDownload !== undefined && item.isDownload !== null
      );
      const storeStickers = collections.filter(
        (item) => item.isDownload === undefined || item.isDownload === null
      );
      const listRecent = recentStickers.stickerRecent;
      const filterRecentStickers = listRecent.filter(
        (item) => item.collectionId !== collectionItem.collectionId
      );
      recentStickers.stickerRecent = filterRecentStickers;
      recentStickers.save();
      this.setState({
        manageStickers,
        storeStickers,
        stickerRecent: filterRecentStickers,
      });
    }
  };

  renderTicketImage() {
    const { selectedCollection, selectedId } = this.state;
    if (selectedCollection !== null) {
      const prefixImage = selectedCollection.prefix;
      if (selectedCollection.isDownload || selectedCollection.isDefault) {
        return (
          <div className="sticker-view">
            {selectedCollection.stickers !== undefined &&
              selectedCollection.stickers.map((item, index) => {
                return (
                  <div className="sticker-item-detail" key={index}>
                    <img
                      key={`${selectedCollection.collectionId}_${item.stickerId}`}
                      onClick={() =>
                        this.handleOnSendStickerMessage(selectedCollection, item)
                      }
                      className="collection-preview"
                      src={`${Config.host}${prefixImage}/${item.img}`}
                    />
                  </div>
                );
              })}
          </div>
        );
      } else {
        return (
          <div className="preview-view">
            <img
              className="collection-preview-img"
              src={`${Config.host}${selectedCollection.collectionPreview}`}
            />
            <ButtonSticker
              type={TYPE_BTN.DOWNLOAD}
              onClick={() => this.handleDownloadCollection(selectedCollection)}
            />
          </div>
        );
      }
    } else {
      if (selectedId === 0) {
        return this.renderRecentStickerItems();
      }
    }
  }

  renderRecentStickerItems() {
    const { stickerRecent, selectedCollection } = this.state;
    if (selectedCollection !== undefined) {
      return (
        <div className="sticker-view">
          {stickerRecent !== undefined &&
            stickerRecent.map((item, index) => {
              const prefixImage = item.prefix;
              return (

                <div className="sticker-item-detail" key={index}>
                  <img
                    key={`${item.collectionId}_${item.stickerId}`}
                    onClick={() => this.handleOnSendStickerMessage(item, item)}
                    className="collection-preview"
                    src={`${Config.host}${prefixImage}/${item.img}`}
                  />
                </div>
              );
            })}
        </div>
      );
    }
  }

  renderStoreStickers() {
    const { storeStickers } = this.state;
    if (storeStickers !== null) {
      return (
        storeStickers !== undefined &&
        storeStickers.map((item, index) => {
          return (
            <div className="store-collections-item" key={index} >
              <div className="store-collections-item-avatar" >
                <img
                  key={`${item.collectionId}`}
                  className="store-collection-avatar"
                  src={`${Config.host}${item.collectionAvatar}`}
                />
              </div>
              <div className="store-collections-item-content">
                <h4
                  key={`${item.collectionId}`}
                  className="store-collection-title"
                >
                  {item.collectionName}
                </h4>
              </div>
              <ButtonSticker
                type={TYPE_BTN.DOWNLOAD}
                onClick={() => this.handleDownloadCollection(item)} />
            </div>
          );
        })
      );
    }
  }

  renderManageStickers() {
    const { manageStickers } = this.state;
    if (manageStickers !== null) {
      return (
        manageStickers !== undefined &&
        manageStickers.map((item, index) => {
          return (
            <div>
              <div className="store-collections-item" key={index} >
                <div className="store-collections-item-avatar">
                  <img
                    key={`${item.collectionId}`}
                    className="store-collection-avatar"
                    src={`${Config.host}${item.collectionAvatar}`}
                  />
                </div>
                <div className="store-collections-item-content">
                  <h4 key={`${item.collectionId}`} className="store-collection-title">
                    {item.collectionName}
                  </h4>
                </div>
                <ButtonSticker
                  type={TYPE_BTN.DELETE}
                  onClick={() => this.handleDeleteCollection(item)} />
              </div>
            </div>
          );
        })
      );
    }
  }

  processScroll() {
    let mouseDown = false;
    let startX, scrollLeft;
    const slider = document.querySelector(".sticker-icon-view");

    // Bắt đầu lắng nghe sự kiện wheel
    slider.addEventListener("wheel", function (event) {
      slider.scrollLeft += event.deltaY;
      event.preventDefault();
    });
    const startDragging = (e) => {
      mouseDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const stopDragging = (e) => {
      mouseDown = false;
    };

    const move = (e) => {
      e.preventDefault();
      if (!mouseDown) {
        return;
      }
      const x = e.pageX - slider.offsetLeft;
      const scroll = x - startX;
      slider.scrollLeft = scrollLeft - scroll;
    };
    slider.addEventListener("mousemove", move, false);
    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("mouseleave", stopDragging, false);
  }

  render() {
    const {
      listStickers,
      screenNumber,
    } = this.state;
    return (
      <div className="sticker-container">
        <div
          style={{
            display: screenNumber === SCREEN_MANAGE_STICKER ? "block" : "none",
          }}
        >
          <div className="selection">
            <div className={`option sticker-store ${this.state.tab === TAB_STORE_STICKER && 'active'}`}>
              <button
                onClick={() =>
                  this.setState({
                    refresh: Date.now(),
                    screenNumber: SCREEN_STICKER,
                    tab: TAB_STICKER,
                  })
                }
                className="back"
              >
                <IconBack />
              </button>
              <button
                style={{ margin: 0, padding: 0 }}
                selected={this.state.tab === TAB_STORE_STICKER}
                onClick={() => {
                  this.updateListSticker(TAB_STORE_STICKER);
                }}
                className="btn-store"
              >
                <FormattedMessage
                  id="sticker_store"
                  defaultMessage="Sticker store"
                />
              </button>
            </div>
            <div className={`option ${this.state.tab === TAB_MANAGE_STICKER && 'active'}`}>
              <button
                style={{ margin: 0, padding: 0 }}
                selected={this.state.tab === TAB_MANAGE_STICKER}
                onClick={() => {
                  this.updateListSticker(TAB_MANAGE_STICKER);
                }}
              >
                <FormattedMessage
                  id="manage_stickers"
                  defaultMessage="Manage Stickers"
                />
              </button>
            </div>
          </div>

          {this.state.tab === TAB_STORE_STICKER && (
            <div
              className="store-stickers-container"
            >
              {this.renderStoreStickers()}
            </div>
          )}
          {this.state.tab === TAB_MANAGE_STICKER && (
            <div
              className="store-stickers-container"
            >
              {this.renderManageStickers()}
            </div>
          )}
        </div>
        {this.state.screenNumber === SCREEN_STICKER && (
          <React.Fragment>
            <div className="selection">
              <div className="option">
                <button
                  onClick={() =>
                    this.setState({ tab: TAB_STICKER }, () =>
                      this.processScroll()
                    )
                  }
                  className={`${this.state.tab === TAB_STICKER && "active"}`}
                >
                  <FormattedMessage
                    id="stickers"
                    defaultMessage="Stickers"
                  />
                </button>
              </div>
              <div className="option">
                <button
                  onClick={() => this.setState({ tab: TAB_EMOJI })}
                  className={`${this.state.tab === TAB_EMOJI && "active"}`}
                >
                  <FormattedMessage
                    id="emoji"
                    defaultMessage="Emoji"
                  />
                </button>
              </div>
            </div>

            {this.state.tab === TAB_STICKER && (
              <React.Fragment>
                {this.renderTicketImage()}

                <div className="container-sticker">
                  <div
                    className="sticker-recent"
                    onClick={() => this.handleOnCollectionClick(0)}
                  >
                    <IconRecent />
                  </div>
                  <div className="sticker-icon-view">
                    {listStickers.map((item, index) => {
                      return (
                        <div className="sticker-item" key={index}>
                          {
                            item.isDefault ? <div
                              key={item.collectionId}
                              className="collection-avatar"
                              onClick={() => this.handleOnCollectionClick(item.collectionId)}
                            >
                              <IconStickerDefault />
                            </div> : <img
                              key={item.collectionId}
                              className="collection-avatar"
                              onClick={() =>
                                this.handleOnCollectionClick(item.collectionId)
                              }
                              src={`${Config.host}${item.collectionAvatar}`}
                            />
                          }
                        </div>
                      );
                    })}
                  </div>

                  <div className="add" onClick={this.handleOnManageClick}>
                    <IconAdd />
                  </div>
                </div>
              </React.Fragment>
            )}
            {this.state.tab === TAB_EMOJI && (
              <div className="emoji-mart">
                <Picker
                  className="emoji-container"
                  data={data}
                  previewPosition="none"
                  navPosition="bottom"
                  dynamicWidth={true}
                  onEmojiSelect={(emoji) => this.handleFocusEmoji(emoji)}
                />
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default injectIntl(Stickers);
